export enum VerticalDepth {
  Primary = 1,
  Sub = 2,
}

export interface Vertical {
  VerticalId: number;
  Name: string;
  Depth: number;
}
